import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image"


const StyledHeroContainer = styled(Container)`

`
const Advanced = () => {
    return (
        <StyledHeroContainer>
            <div className="row">
                <div className="col-sm-6">
                    <p><span className="fw-bolder fs-5">Deduplication</span></p>
                    <p>Dropcontact fails to identify duplicate entries and charges for them as well. Whereas, Clearout identifies duplicates in the same list, removes them, and does not charge for duplicate leads.</p>
                </div>
                <div className="col-sm-6 ">
                    <StaticImage src="../../../images/deduplication_co_vs_dropcontact.jpg" alt="Validate email address with Clearout's Email Verifier for accurate results and guaranteed email deliverability" placeholder="blurred" />
                </div>
            </div>

        </StyledHeroContainer>
    )
}

export default Advanced;